import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { openCookieSettings } from "../cookies/consent";
import { dateLocale } from "../i18n";
import classes from "./privacy.module.css";

type PrivacyItem = {
  label?: string;
  text: string;
};

type PrivacySection = {
  title: string;
  intro?: string;
  items?: PrivacyItem[];
  closing?: string;
  contact?: string;
};

export const Privacy = () => {
  const { t } = useTranslation();
  const sections = t("privacy.sections", {
    returnObjects: true,
  }) as PrivacySection[];
  const updated = new Date().toLocaleDateString(dateLocale(), {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <main className={classes.container}>
      <div className={classes.content}>
        <Link to="/" className="pp-back">
          {t("common.backHome")}
        </Link>
        <h1 className={classes.title}>{t("privacy.title")}</h1>
        <p className={classes.lastUpdated}>
          {t("privacy.updated", { date: updated })}
        </p>
        <button
          type="button"
          className={classes.cookieButton}
          onClick={openCookieSettings}
        >
          {t("cookies.change")}
        </button>

        {sections.map((section) => (
          <section className={classes.section} key={section.title}>
            <h2 className={classes.sectionTitle}>{section.title}</h2>
            {section.intro && <p className={classes.text}>{section.intro}</p>}
            {section.items && (
              <ul className={classes.list}>
                {section.items.map((item) => (
                  <li key={`${item.label ?? ""}${item.text}`}>
                    {item.label && <strong>{item.label} </strong>}
                    {item.text}
                  </li>
                ))}
              </ul>
            )}
            {section.closing && (
              <p className={classes.text}>{section.closing}</p>
            )}
            {section.contact && (
              <p className={classes.contact}>
                <strong>{t("common.email")}:</strong> {section.contact}
              </p>
            )}
          </section>
        ))}
      </div>
    </main>
  );
};
